import { fetchJson } from './apiClient';

export type BulkRequest = {
  id: string;
  type: string;
  status: 'pending' | 'approved' | 'rejected' | string;
  createdByEmail?: string;
  createdById?: string;
  reviewedBy?: string;
  payload?: any;
};

export type BulkRequestsPage = {
  items: BulkRequest[];
  total: number;
  page: number;
  pageSize: number;
};

export type BulkRequestsQuery = {
  status?: 'all' | 'pending' | 'approved' | 'rejected';
  q?: string;
  from?: string; // ISO date string
  to?: string;   // ISO date string
  page?: number;
  limit?: number;
  type?: 'sms' | 'email';
};

export async function listBulkRequests(params: BulkRequestsQuery = {}): Promise<BulkRequestsPage> {
  const usp = new URLSearchParams();
  if (params.status) usp.set('status', params.status);
  if (params.q) usp.set('q', params.q);
  if (params.from) usp.set('from', params.from);
  if (params.to) usp.set('to', params.to);
  if (params.page) usp.set('page', String(params.page));
  if (params.limit) usp.set('limit', String(params.limit));
  if (params.type) usp.set('type', params.type);
  const qs = usp.toString();
  return fetchJson(`/api/admin/bulk-requests${qs ? `?${qs}` : ''}`);
}

export async function reviewBulkRequest(id: string, action: 'approve' | 'reject'): Promise<BulkRequest> {
  return fetchJson(`/api/admin/bulk-requests/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify({ action }),
  });
}

export async function createBulkRequest(payload: any): Promise<{ id: string } & BulkRequest> {
  // Server expects { type, payload }
  const type = payload?.type;
  const wrapped = { type, payload };
  return fetchJson(`/api/admin/bulk-requests`, {
    method: 'POST',
    body: JSON.stringify(wrapped),
  });
}

export default { listBulkRequests, reviewBulkRequest };
